<template>
  <div>
    <div class="top-text m-4">
      {{ $t('selectFunds') | capitalize }}
    </div>
    <div class="m-4">
      <v-server-table
        :url="`fundsfiles/?undistributed=true`"
        :columns="columns"
        :options="options"
      >
        <!--SELECT COLUMN-->
        <template v-slot:select="{ row }">
          <p-check
            :checked="isSelected(row)"
            class="p-icon p-curve p-pulse ml-3"
            color="success"
            @change="toggleSelected(row)"
          >
            <template v-slot:extra>
              <i class="icon fa fa-check"/>
            </template>
          </p-check>
        </template>

        <template v-slot:path="{ row }">
          {{ row.path.split('/').pop() }}
        </template>
      </v-server-table>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.top-text {
  font-size: 22px;
  font-weight: 500;
  margin-top: 40px;
}
</style>

<script>
import { capitalize, get } from "lodash"
import {
  doRequest,
  responsePaginatedAdapter
} from "@/assets/libs/utils"

export default {
  name: "FundsFileSelector",
  data () {
    return {
      fundsFile: null,
      columns: ["select", "path", "status"],
      options: {
        sortable: [],
        headings: {
          select: capitalize(this.$t("select")),
          path: capitalize(this.$t("fileName")),
          status: capitalize(this.$t("status")),
        },
        requestFunction (params) {
          return doRequest(this.url, params)
        },
        responseAdapter: resp => {
          return responsePaginatedAdapter(resp)
        }
      }
    }
  },
  methods: {
    isSelected (row) {
      return get(this.fundsFile, "id") === row.id
    },
    toggleSelected (row) {
      this.fundsFile = this.isSelected(row) ? null : row
    }
  },
  watch: {
    // Handles internal model changes.
    fundsFile (newVal) {
      this.$emit("input", newVal)
    },
    // Handles external model changes.
    value (newVal) {
      this.fundsFile = newVal
    }
  },
  props: {
    value: null
  },
  created () {
    if (this.value) {
      this.fundsFile = this.value
    }
  }
}
</script>
